var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from "@mui/material";
import { combineSxProps } from "../../Utils";
const sizeMap = {
    small: "24px",
    medium: "32px",
    large: "40px"
};
export const TruffleAvatar = (props) => {
    const _a = Object.assign({}, props), { sx, size: sizeProp } = _a, avatarProps = __rest(_a, ["sx", "size"]);
    const size = sizeProp || "medium";
    let children = undefined;
    let fontSize = undefined;
    if ("icon" in avatarProps) {
        children = avatarProps.icon;
        delete avatarProps.icon;
        switch (size) {
            case "small":
                fontSize = "16px";
                break;
            case "medium":
            case "large":
                fontSize = "19px";
                break;
        }
    }
    else if ("text" in avatarProps) {
        children = avatarProps.text;
        delete avatarProps.text;
        switch (size) {
            case "small":
                fontSize = "12px";
                break;
            case "medium":
            case "large":
                fontSize = "16px";
                break;
        }
    }
    else if ("image" in avatarProps) {
        avatarProps.src = avatarProps.image;
        delete avatarProps.image;
    }
    return _jsx(Avatar, Object.assign({ sx: combineSxProps(sx, { width: sizeMap[size], height: sizeMap[size], fontSize: fontSize }) }, avatarProps, { children: children }));
};
//# sourceMappingURL=TruffleAvatar.js.map